import { useState } from 'react'
import { publicationInboxService } from '@/services/publication-inbox-service'
import { apiErrorMessage } from '@/services/team-service'
import * as toast from '@/lib/toast'

export type ConferenceAction = 'conferir' | 'desconferir'

const MAX_LOTE = 100

/**
 * Marca publicações como conferidas (ou desfaz), uma ou várias, avisa o
 * resultado e chama `onDone` para a página recarregar lista e contagens.
 */
export function useInboxConference(onDone: () => void) {
  const [busy, setBusy] = useState(false)

  const run = async (action: ConferenceAction, ids: number[]): Promise<boolean> => {
    if (ids.length === 0 || busy) return false
    setBusy(true)
    try {
      if (ids.length === 1) {
        await (action === 'conferir' ? publicationInboxService.conferir(ids[0]) : publicationInboxService.desconferir(ids[0]))
        toast.success(action === 'conferir' ? 'Publicação conferida' : 'Conferência desfeita')
      } else {
        let ok = 0
        let falhas = 0
        for (let i = 0; i < ids.length; i += MAX_LOTE) {
          const result = await publicationInboxService.emLote(action, ids.slice(i, i + MAX_LOTE))
          ok += result.ok.length
          falhas += result.falhas.length
        }
        const verbo = action === 'conferir' ? 'conferida(s)' : 'com conferência desfeita'
        if (falhas > 0) toast.error(`${ok} publicação(ões) ${verbo}; ${falhas} com erro`)
        else toast.success(`${ok} publicação(ões) ${verbo}`)
      }
      return true
    } catch (err) {
      toast.error(apiErrorMessage(err, 'Não foi possível atualizar a conferência'))
      return false
    } finally {
      setBusy(false)
      onDone()
    }
  }

  return { busy, run }
}
